import React from "react";
import { Result, Button, Typography } from "antd";
import { WifiOutlined } from "@ant-design/icons";

const NotIntranetPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f0f5ff, #e6f7ff)"
      }}
    >
      <Result
        icon={<WifiOutlined style={{ color: "#1890ff" }} />}
        title={
          <Typography.Title level={2}>การเข้าถึงถูกจำกัด</Typography.Title>
        }
        subTitle={
          <Typography.Text type="secondary">
            ระบบนี้สามารถเข้าถึงได้จากภายในองค์กรเท่านั้น (อินทราเน็ต)
            กรุณาเชื่อมต่อเข้ากับเครือข่ายขององค์กรแล้วลองใหม่อีกครั้ง
          </Typography.Text>
        }
        extra={
          <Button
            type="primary"
            onClick={() => window.location.reload()}
            style={{ borderRadius: 8 }}
          >
            ลองอีกครั้ง
          </Button>
        }
        style={{
          padding: 24,
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          maxWidth: 500
        }}
      />
    </div>
  );
};

export default NotIntranetPage;
